// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"545752cb","488":"c7039015","553":"7b8f2880"}[chunkId] + ".chunk.js";
};